import React, { useState, useEffect } from 'react';

export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <a href="/" className="flex items-center">
            <h1 className={`text-xl md:text-2xl font-bold transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`} style={{ fontFamily: '"Pacifico", serif' }}>
              おかやま司法書士事務所
            </h1>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-2">
            <a
              href="/"
              className={`px-4 py-2 rounded-lg transition-colors whitespace-nowrap text-sm ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/20'
              }`}
            >
              ホーム
            </a>
            <a
              href="/about"
              className={`px-4 py-2 rounded-lg transition-colors whitespace-nowrap text-sm ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/20'
              }`}
            >
              会社概要
            </a>
            <a
              href="/recruit"
              className={`px-4 py-2 rounded-lg transition-colors whitespace-nowrap text-sm ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/20'
              }`}
            >
              求人情報
            </a>
            <a
              href="/blog"
              className={`px-4 py-2 rounded-lg transition-colors whitespace-nowrap text-sm ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/20'
              }`}
            >
              ブログ
            </a>
            <a
              href="tel:086-012-3456"
              className={`ml-4 px-6 py-2 rounded-lg transition-colors whitespace-nowrap text-sm font-medium ${
                isScrolled
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-white text-blue-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-phone-line mr-2"></i>
              086-012-3456
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden w-10 h-10 flex items-center justify-center ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col space-y-2">
              <a
                href="/"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 transition-colors text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                ホーム
              </a>
              <a
                href="/about"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 transition-colors text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                会社概要
              </a>
              <a
                href="/recruit"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 transition-colors text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                求人情報
              </a>
              <a
                href="/blog"
                className="px-4 py-3 text-gray-700 hover:bg-gray-100 transition-colors text-sm"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                ブログ
              </a>
              <a
                href="tel:086-012-3456"
                className="mx-4 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-center text-sm font-medium whitespace-nowrap"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
